export const getCreatedHiddenInput = (name, value) => {
  const input = document.createElement("input");
  input.setAttribute("type", "hidden");
  input.setAttribute("id", name);
  input.setAttribute("name", name);
  input.setAttribute("value", value);
  return input
}

export const paymentOnSubmitTrack = () => {
  try {
    const browserData = {
      platform: window.navigator.platform,
      javaEnabled: window.navigator.javaEnabled(),
      language: window.navigator.language,
      colorDepth: window.screen.colorDepth,
      screenHeight: window.screen.availHeight,
      screenWidth: window.screen.availWidth,
      timeZoneOffset: window.navigator.timeZoneOffset,
      userAgent: window.navigator.userAgent,
      ...Intl.DateTimeFormat().resolvedOptions(),
      time: new Date().getTime(),
    }
    const form = event.target.closest("form");
    if (!form) {
      return
    }
    Object.keys(browserData).forEach(property => {
      const input = getCreatedHiddenInput(property, browserData[property]);
      form.appendChild(input);
    })
  } catch (e) {
    console.log("error", e);
  }
}

export const canUseLocalStorage = () => {
  let storage;
  try {
    storage = window.localStorage;
    const x = "__storage_test__";
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      e.name === "QuotaExceededError" &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage &&
      storage.length !== 0
    );
  }
}